export default __webpack_public_path__ + "static/media/Arrow.4d7fec30.svg";